import React from 'react';
import classNames from 'classnames';
import css from './Button.module.scss';
import { fireAnalyticsEvent } from '../../analytics';

import Link from '@components/Link/Link';
import PrismicLink from '@components/PrismicLink/PrismicLink';

// Same component as <LinkButton /> but instead it wraps the children in a PrismicLink instead of Link
export const PrismicButton = props => {
  const { to, children, theme, large, ...rest } = props;
  // Current button themes:
  // - default: white on dark, hover tomato
  // - dark: white on dark, hover black
  // - white: white button, hover tomato
  // - positive: white on green, hover darker green
  const classes = classNames(css.button, {
    [css.themeDark]: theme === 'dark',
    [css.themeWhite]: theme === 'white',
    [css.themePositive]: theme === 'positive',
    [css.large]: large,
  });

  return (
    <PrismicLink className={classes} to={to} {...rest}>
      {children}
    </PrismicLink>
  );
};

export const LinkButton = props => {
  const { to, children, theme, large, ...rest } = props;

  // Current button themes:
  // - default: white on dark, hover tomato
  // - dark: white on dark, hover black
  // - white: white button, hover tomato
  // - positive: white on green, hover darker green
  const classes = classNames(css.button, {
    [css.themeDark]: theme === 'dark',
    [css.themeWhite]: theme === 'white',
    [css.themePositive]: theme === 'positive',
    [css.large]: large,
  });

  return (
    <Link className={classes} to={to} {...rest}>
      {children}
    </Link>
  );
};

const noop = () => undefined;

export const Button = props => {
  const { children, onClick = noop, analyticsEvent, ...rest } = props;
  const buttonProps = {
    onClick: e => {
      if (analyticsEvent) {
        fireAnalyticsEvent(analyticsEvent);
      }
      return onClick(e);
    },
    ...rest,
  };
  return (
    <button className={css.button} {...buttonProps}>
      {children}
    </button>
  );
};
